<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          RELATÓRIO DE FATURAS DE REEMBOLSO CANCELADAS
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="3">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="getLogs"
              >
                Executar Consulta
              </v-btn>
            </v-col>
            <v-col cols="12" xs="6" md="5">
              <v-btn
                :disabled="logs.length == 0"
                @click="exportLogs('excel')"
                color="grey darken-4"
                outlined
                small
                class="mt-1 float-right"
              >
                <v-icon color="green" left> mdi-file-excel-box </v-icon>
                Excel
              </v-btn>
              <v-btn
                :disabled="logs.length == 0"
                @click="exportLogs('pdf')"
                color="grey darken-4"
                outlined
                small
                class="mt-1 mr-1 float-right"
              >
                <v-icon color="red" left> mdi-file-pdf-box </v-icon>
                PDF
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="380">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left fs-12 text-no-wrap">
                                Filial
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Franqueado
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Documento
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Vr. Documento
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Parcelas
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Data de Criação
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Data Cancelamento
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Usuário
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Motivo
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Observação
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="log in logs" :key="log.id">
                              <td>
                                {{ log.company.code }}
                              </td>
                              <td>
                                {{ log.company.name }}
                              </td>
                              <td>{{ log.company.code }}-{{ log.document }}</td>
                              <td class="text-right">
                                {{ log.value }}
                              </td>
                              <td class="text-right">
                                {{ log.parcels }}
                              </td>
                              <td>
                                {{ dateToBr(log.date_billing) }}
                              </td>
                              <td>
                                {{ datetimeToBr(log.created_at) }}
                              </td>
                              <td>{{ log.user }}</td>
                              <td>
                                {{ log.reason.description }}
                              </td>
                              <td>
                                {{ log.observation }}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="logs.length > 0">
                            <tr>
                              <th colspan="10">
                                Total de Faturas:
                                {{ logs.length }}
                              </th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";

export default {
  components: { Alert },
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    logs: [],
    showAlert: false,
    typeAlert: "error",
    messageAlert: "",
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {
      // await this.getLogs();
    },
    validate() {},
    async getLogs() {
      this.showAlert = false;
      this.loading = true;
      this.logs = [];
      try {
        let response = await fetch(
          `${URL}refund-cancellation-log?month=${this.month}&year=${this.year}`
        );
        let res = await response.json();
        this.logs = res.map((item) => ({ ...item, user: "FERNANDA" }));
        console.table(this.logs);
      } catch (error) {
        console.log(error);
        this.messageAlert =
          "Não foi possível carregar os Logs dos Cancelmentos de Faturas de Reembolso, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    dateToBr(date) {
      if (date == "") return;
      return date.split("-").reverse().join("/");
    },
    datetimeToBr(datetime) {
      if (datetime == "") return;
      let [date, time] = datetime.split(" ");
      return `${date.split("-").reverse().join("/")} ${time}`;
    },
    async exportLogs(type) {
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      let data = {};
      data.type = type;
      data.month = this.month;
      data.year = this.year;
      data.logs = this.logs;

      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}refund-cancellation-log/export/${type}`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.download.name = response.nome;
        this.download.link = `${URL}refund-cancellation-log/download/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-area-uppercase textarea {
  text-transform: uppercase;
}
</style>
